import { apiGet, apiPost, apiPut, apiDelete } from "@redriver/cinnamon";

const NAMESPACE = "CUSTOMERS/DETAILS/CONTACTS";

export const ActionTypes = {
  GetCustomerContacts: `${NAMESPACE}/GET_CUSTOMER_CONTACTS`,
  AddCustomerContact: `${NAMESPACE}/ADD_CUSTOMER_CONTACT`,
  EditCustomerContact: `${NAMESPACE}/EDIT_CUSTOMER_CONTACT`,
  DeleteCustomerContact: `${NAMESPACE}/DELETE_CUSTOMER_CONTACT`,
};

export const getCustomerContacts = (_, { customerId }) =>
  apiGet(ActionTypes.GetCustomerContacts, `customers/${customerId}/contacts`);

export const addCustomerContact = (contact, { customerId }) =>
  apiPost(
    ActionTypes.AddCustomerContact,
    `customers/${customerId}/contacts`,
    contact,
  );

export const editCustomerContact = (contact, { customerId, contactId }) =>
  apiPut(
    ActionTypes.EditCustomerContact,
    `customers/${customerId}/contacts/${contactId}`,
    {
      ...contact,
    },
  );

export const deleteCustomerContact = ({ customerId, contactId }) =>
  apiDelete(
    ActionTypes.DeleteCustomerContact,
    `customers/${customerId}/contacts/${contactId}`,
  );
